<template>
  <div class="navBar">
    <i class="nav-icon fas fa-bars" @click="toggleNavBar"></i>
    <transition name="slide">
      <div class="mobile-nav" v-show="showNavBar">
        <p class="navName">
          Anastasia
          <br />Laczko
        </p>
        <router-link to="/" class="navLink" @click.native="toggleNavBar"
          >Home</router-link
        >
        <router-link to="/about" class="navLink" @click.native="toggleNavBar"
          >About</router-link
        >
        <router-link
          to="/experience"
          class="navLink"
          @click.native="toggleNavBar"
          >Experience</router-link
        >
        <router-link to="/projects" class="navLink" @click.native="toggleNavBar"
          >Projects</router-link
        >
        <router-link to="/contact" class="navLink" @click.native="toggleNavBar"
          >Contact</router-link
        >
        <!-- <a
          href="./files/ANASTASIA_LACZKO_Resume.pdf"
          target="_blank"
          rel="nofollow noopener noreferrer"
          class="navLink resume"
          >Resume</a
        > -->
      </div>
    </transition>
    <div class="general-nav">
      <router-link to="/" class="navLink navName">
        Anastasia <br />Laczko
      </router-link>
      <router-link to="/about" class="navLink">About</router-link>
      <router-link to="/experience" class="navLink">Experience</router-link>
      <router-link to="/projects" class="navLink">Projects</router-link>
      <router-link to="/contact" class="navLink">Contact</router-link>
      <!-- <a
        href="./files/ANASTASIA_LACZKO_Resume.pdf"
        target="_blank"
        rel="nofollow noopener noreferrer"
        class="navLink resume"
        >RESUME <i class="fas fa-arrow-circle-down"></i
      ></a> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showNavBar: false
    };
  },

  methods: {
    toggleNavBar() {
      this.showNavBar = !this.showNavBar;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_font.scss";
@import "@/assets/_colours.scss";

.navBar {
  top: 0;
  left: 0;
  height: 100vh;
  background-color: white;
  border-right: solid 1px $blue-grey;
  z-index: 50;

  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.5s ease;
  }

  .slide-enter,
  .slide-leave-to {
    margin-left: -200px;
  }

  /*
you set the css property it will be when transition ends
*/
  .slide-enter-to,
  .slide-leave {
    margin-left: 0px;
  }

  .nav-icon {
    font-size: 40px;
    position: absolute;
    top: 0;
    left: 0;
    padding: 20px;

    &:hover {
      cursor: pointer;
    }

    z-index: 100;
  }

  & > div {
    .navName {
      font-family: "Roboto", sans-serif;
      font-size: 30px !important;
      font-weight: 600;
      color: $dark-grey !important;
    }

    .navName:hover {
      text-decoration-color: $dark-grey;
    }

    .navLink {
      color: $light-grey;
      display: block;
      text-decoration: none;
        font-weight: 600;
    }

    .navLink:hover {
      text-decoration: underline;
    }

    .router-link-exact-active {
      color: $accent-blue;
    }

    .resume {
      margin: 0 auto;
      background: $accent-lightest-blue;
      font-size: $font-XS !important;
      font-weight: 600;
      color: $accent-darker-blue;
      padding: 10px 20px;
      border-radius: 2em;
      transition: 0.3s;
      text-align: center;
      letter-spacing: 1px;
      text-decoration: none !important;

      &:hover {
        color: $accent-very-dark-blue;
        background: $accent-very-light-blue;
        cursor: pointer;
      }
    }
  }
}

@media only screen and (min-width: $phone-S) {
  .navBar {
    position: fixed;

    & > div {
      padding: 70px 100px 0 50px;

      .navName {
        margin-bottom: 20px;
      }

      .navLink {
        margin-bottom: 20px;
        font-size: $font-S;
      }
    }

    .general-nav {
      display: none;
    }
  }
}

@media only screen and (min-width: $phone-L) {
  //to fill
}

@media only screen and (min-width: $tablet-potrait) {
  //to fill
}

@media only screen and (min-width: $tablet-landscape) {
  //to fill
}

@media only screen and (min-width: $desktop) {
  .navBar {
    position: sticky;
    display: flex;
    align-items: center;

    .nav-icon {
      display: none;
    }

    & > div {
      padding: 30px;

      .navName {
        margin-bottom: 40px;
      }

      .navLink {
        margin-bottom: 30px;
        font-size: $font-S;
      }
    }

    .general-nav {
      display: block;
    }

    .mobile-nav {
      display: none;
    }
  }
}

@media only screen and (min-width: $desktop-lg) {
  //to fill
}
</style>
